import {createSelector} from 'reselect'

export const getActivePortfolioId = (state) => state.app.activePortfolioId

export const getTranslations = (state) => state.app.translations

export const getNotifications = (state) => state.app.notifications

export const getL = createSelector(
  [getTranslations],
  (translations) => (string) => translations[string] || string,
)



// WEBPACK FOOTER //
// ./src/store/app/selectors.js